export default interface DigitalDocumentStudentConfirmationFormModel {
  studentStartDate: string;
  schoolType?: DigitalDocumentStudentConfirmationSchoolTypeEnum;
  schoolName: string;
  schoolTown: string;
  schoolProfile: string;
}

export enum DigitalDocumentStudentConfirmationSchoolTypeEnum {
  University = 1,
  School = 2
}
